import { ErrorModal } from "@dexteel/mesf-core";
import { CircularProgress, TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { FieldError } from "react-hook-form";
import { PourbackReason } from "../model/PourbackReason";
import { getPourbackReasons } from "../repositories/PourbackReasonRepository";

type Props = {
  label: string;
  value: number | null;
  onChange?: Function;
  fieldError: FieldError | undefined;
  disabled?: boolean;
};

export const PourbackReasonAutocomplete = ({
  label,
  value,
  onChange = () => {},
  fieldError,
  disabled = false,
}: Props) => {
  const [PourbackReasons, setPourbackReasons] = useState<PourbackReason[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState("");

  const loadData = async () => {
    setIsLoading(true);
    setError("");
    const resp = await getPourbackReasons();
    if (resp.ok) {
      const rows = get(resp, "data.tables[0].rows", []) as PourbackReason[];
      setPourbackReasons(rows);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  const selectedValue =
    PourbackReasons?.find(
      (ms: PourbackReason) => ms.PourbackReasonId === value,
    ) || null;

  useEffect(() => {
    loadData().then(() => {});
    return;
  }, []);

  return (
    <>
      <Autocomplete
        id="clear-on-escape"
        clearOnEscape
        options={PourbackReasons ?? []}
        getOptionLabel={(option) => option.PourbackReasonName}
        onChange={(event, newValue) => {
          onChange(newValue ? newValue.PourbackReasonId : null);
        }}
        renderInput={(params) => (
          <>
            <TextField
              {...params}
              label={label}
              variant="outlined"
              size="small"
              fullWidth
              error={!!fieldError}
              helperText={fieldError?.message}
              slotProps={{
                input: {
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {isLoading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : (
                        params.InputProps.endAdornment
                      )}
                    </>
                  ),
                },
              }}
            />
          </>
        )}
        disabled={disabled}
        value={selectedValue}
      />
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
